module.exports = __webpack_public_path__ + "static/media/YogaWeb.1182ed84.webp";